const STORAGE_KEY = "redo_localization_enabled";

class LocalizationConfig {
  private enabled: boolean;

  constructor() {
    this.enabled = this.readFromStorage();
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    this.writeToStorage(enabled);
  }

  private readFromStorage(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  }

  private writeToStorage(enabled: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY, String(enabled));
    } catch {
      // localStorage may not be available
    }
  }
}

export const localizationConfig = new LocalizationConfig();
